import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { Input, Button, Field, Control, Icon, Delete, Tag } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSystemCodes } from "../../utils/hooks";

export const getTotalDriverTime = route => {
  const {
    LoadTime = 0,
    TravelTime = 0,
    UnloadTime = 0,
    ReturnToTerminalTime = 0
  } = route;
  return LoadTime + TravelTime + UnloadTime + ReturnToTerminalTime;
};

const OrderItem = ({ order, active, updateOrder, onClear, untripped }) => {
  const SystemCodes = useSystemCodes({
    Category: "Order",
    CodeName: "OrderStatus",
    CodeId: "SCH"
  });
  const [state, setState] = useState(() => ({
    trip: order.Trip || "",
    leg: order.Leg || ""
  }));
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setState({
      trip: order.Trip || "",
      leg: order.Leg || ""
    });
  }, [order]);

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    const tripKey = order.TripKey || "";
    const [date, location] = tripKey.split("_");

    if (state.trip) {
      await updateOrder({
        ...order,
        Trip: parseInt(state.trip),
        Leg: parseInt(state.leg),
        TripKey: `${date}_${location}_${state.trip}`
      });
    } else {
      await onClear(order);
    }

    setLoading(false);
  };
  const handleClear = async () => {
    setLoading(true);
    await onClear(order);
    setLoading(false);
  };

  const handleChange = name => e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setState(prevState => ({ ...prevState, [name]: value }));
  };

  return (
    <div
      className={[
        "order-item",
        active && "is-active",
        untripped && "is-untripped",
        order.ComplexTrip && "is-complex"
      ]
        .filter(Boolean)
        .join(" ")}
      id={`order-${order.RecId}`}
      style={{ fontFamily: "Roboto" }}
      title={`Order #${order.OrderNumber}`}
    >
      <div>
        <b style={{ fontSize: 16 }}>
          #{order.OrderNumber}{" "}
          {state.trip && state.leg ? ` - T${state.trip}L${state.leg}` : ""}
        </b>
        <br />
        <b style={{ fontSize: 18 }}>{order.Customer.Name}</b>
        <br />
        <br />
        <Tag.Group>
          {SystemCodes?.data?.length > 0 && (
            <Tag
              color={
                order.StatusRecIdRef === SystemCodes.data[0].RecId
                  ? "warning"
                  : ""
              }
            >
              <span style={{ fontWeight: "bolder" }}>
                {order.Status.CodeDescription}
              </span>
            </Tag>
          )}
          {order.BookingCode ? (
            <Tag
              style={{
                backgroundColor: order.BookingCode?.Color
              }}
            >
              <span style={{ color: "BLACK", fontWeight: "bolder" }}>
                {order.BookingCode.BookingCode} -{" "}
                {order.BookingCode.Description}
              </span>
            </Tag>
          ) : null}
        </Tag.Group>
        <div>
          {order.PickupDriver &&
            `${order.PickupDriver.FirstName.substr(0, 1)}. ${
              order.PickupDriver.LastName
            }`}
        </div>
        <div>
          {order.PickupTractor &&
            `${order.PickupTractor.VehicleNumber} - ${order.PickupTractor.Description}`}
        </div>
        <div>{order.Route.Contract}</div>
        <div>
          {order.Route.DeliveryLocation.City},{" "}
          {order.Route.DeliveryLocation.State}
        </div>
        <div>
          Arrival Date:{" "}
          <b>
            {moment(order.PickupDate)
              .add(order.Route.LoadTime + order.Route.TravelTime, "hours")
              .format("MM/DD/YYYY HH:mm:ss")
              .toString()}
          </b>
        </div>
        {order.BayNumber && (
          <div className="clear">
            <Delete onClick={handleClear} />
          </div>
        )}
      </div>
      {order.BayNumber && (
        <form className="trip-assign" onSubmit={handleSubmit}>
          <Field kind="addons">
            <Control>
              <Input
                name="trip"
                placeholder="Trip"
                type="text"
                value={state.trip}
                onChange={handleChange("trip")}
                onMouseDown={e => {
                  e.stopPropagation();
                }}
              />
            </Control>
            <Control>
              <Input
                name="leg"
                placeholder="Leg"
                type="text"
                value={state.leg}
                onChange={handleChange("leg")}
                onMouseDown={e => {
                  e.stopPropagation();
                }}
              />
            </Control>
            <Control>
              <Button
                color="primary"
                role="button"
                state={loading ? "loading" : ""}
                type="submit"
              >
                <Icon>
                  <FontAwesomeIcon icon="check" size="sm" />
                </Icon>
              </Button>
            </Control>
          </Field>
        </form>
      )}
    </div>
  );
};
OrderItem.propTypes = {
  order: PropTypes.object,
  updateOrder: PropTypes.func,
  onClear: PropTypes.func,
  active: PropTypes.bool,
  untripped: PropTypes.bool
};
export default OrderItem;
